import { useState } from "react";
import { UserPlus } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";

export function InternalUsersCard({ onDone }: { onDone: () => void }) {
  const [busy, setBusy] = useState(false);
  const create = async () => {
    setBusy(true);
    try {
      const { data } = await api.post<{ created_users: number }>("/admin/internal-users/create");
      toast.success(data.created_users ? `Cuentas internas creadas: ${data.created_users}` : "Las cuentas internas ya se habían creado antes; no se vuelven a crear");
      onDone();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-7" data-testid="internal-users-card">
      <h3 className="font-display text-base font-bold text-[#1B2A4A]">Cuentas de prueba internas</h3>
      <p className="mt-1 text-sm text-slate-500">Crea a Daniel Treviño y Carlos Villarreal con todos sus datos. Funciona una sola vez: si después los borras, no vuelven a aparecer.</p>
      <Button variant="outline" disabled={busy} onClick={create} className="mt-4" data-testid="internal-users-create-button">
        <UserPlus className="mr-2 h-4 w-4" /> Crear cuentas internas
      </Button>
    </div>
  );
}
